import React, { ReactNode } from 'react';
import styled from 'styled-components';

type IColor = 'red' | 'green' | 'yellow' | 'default';

type IProps = {
  children: ReactNode;
  color: IColor;
};

const Wrapper = styled.div<{ color: IColor }>`
  display: inline-block;
  color: ${props =>
    props.color === 'default'
      ? 'var(-white)'
      : props.color === 'green'
      ? 'var(--green4)'
      : props.color === 'yellow'
      ? 'var(--warnContent)'
      : 'var(--red3)'};
`;

const TextColored = ({ children, color }: IProps) => (
  <Wrapper color={color}>{children}</Wrapper>
);

export default TextColored;
